var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowHideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 1.95833C14.4742 1.95833 17.5726 3.91083 19.0851 7C17.5726 10.0892 14.4834 12.0417 11.0001 12.0417C7.51675 12.0417 4.42758 10.0892 2.91508 7C4.42758 3.91083 7.52591 1.95833 11.0001 1.95833ZM11.0001 0.125C6.41675 0.125 2.50258 2.97583 0.916748 7C2.50258 11.0242 6.41675 13.875 11.0001 13.875C15.5834 13.875 19.4976 11.0242 21.0834 7C19.4976 2.97583 15.5834 0.125 11.0001 0.125ZM11.0001 4.70833C12.2651 4.70833 13.2917 5.735 13.2917 7C13.2917 8.265 12.2651 9.29167 11.0001 9.29167C9.73508 9.29167 8.70841 8.265 8.70841 7C8.70841 5.735 9.73508 4.70833 11.0001 4.70833ZM11.0001 2.875C8.72675 2.875 6.87508 4.72667 6.87508 7C6.87508 9.27333 8.72675 11.125 11.0001 11.125C13.2734 11.125 15.1251 9.27333 15.1251 7C15.1251 4.72667 13.2734 2.875 11.0001 2.875Z",
    fill: "#9095A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowHideIcon);
export default __webpack_public_path__ + "static/media/show-hide-icon.ac67a834dc296beda9ce874b05bd80a0.svg";
export { ForwardRef as ReactComponent };